import { SkeletonBox, SkeletonText } from '@billy/design-system'
import { ReactElement } from 'react'

import * as Styled from './styles'

export const FecImportFileListSkeleton = (): ReactElement => (
  <Styled.FecImportFileListSkeletonWrapper data-testid="fec-import-file-list-skeleton">
    <SkeletonBox height={32} width={32} />
    <Styled.FecImportFileListSkeletonTextWrapper>
      <SkeletonText width={140} />
      <SkeletonText width={60} />
    </Styled.FecImportFileListSkeletonTextWrapper>
  </Styled.FecImportFileListSkeletonWrapper>
)
